module.exports = __webpack_public_path__ + "img/I004_R_home slider.80c049f9.jpg";